// Expenses Reducer
const accountsReducerDefaultState = [];

export default (state = accountsReducerDefaultState, action) => {
    switch (action.type) {
        case 'SET_ACCOUNTS':
            return action.accounts

        case 'ADD_ACCOUNT':
            return [
                ...state,
                action.account
            ];
        case 'REMOVE_ACCOUNT':
            return state.filter(({ id }) => id !== action.id);
        case 'EDIT_ACCOUNT':
            return state.map((account) => {
                if (account.id === action.id) {
                    return {
                        ...account,
                        ...action.updates
                    };
                } else {
                    return account;
                };
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/accounts.js